<nav class="b2b-ops-nav" *ngIf="contractId" aria-label="Operacional B2B">
  <a
    *ngFor="let link of links"
    class="b2b-ops-nav-link"
    [class.active]="active === link.key"
    [routerLink]="['/b2b/contracts', contractId, link.path]">
    <i [class]="link.icon"></i>
    <span>{{ link.label }}</span>
  </a>
</nav>
